import React, { useCallback } from "react";

import styles from "./styles.css";

const PercentInput = ({ onChange, value, ...props }) => {
	const handleChange = useCallback(event => {
		onChange && onChange(event.target.value, event);
	}, [ onChange ]);

	return (
		<div className={styles.percentInput}>
			<input
				{...props}
				type="number"
				value={value}
				onChange={handleChange}
			/>
		</div>
	);
};

export default PercentInput;
